import { productionMode } from './environment.js';
import { cameras } from '../view/cameras.js';
import { settings } from '../settings.js';

const imageFiles = [
    'zoom_in', 'zoom_out', 'draw', 'erase', 'hand', 'paint', 'undo', 'redo',
    'select', 'wand', 'menu', 'bead_mode', 'matte', 'semigloss', 'gloss',
    'chest', 'search', 'cylinder_matte', 'cylinder_semigloss', 'cylinder_gloss',
    'mirror', 'rectangle', 'marquee', 'image', 'transform', 'camera', 'ruler', 'more_tools',
    'rotate_right', 'rotate_left', 'rotate_180', 'flip_horizontal',
    'flip_vertical', 'palette_down', 'palette_up', 'palette', 'arrow', 'rotate',
    'info', 'eyedropper', 'download', 'cylinder_insidecolor', 'cylinder_transparent', 'round_corners', 'round_corners_white',
    'round_insidecolor', 'round_transparent', 'soup', 'trash', 'bake', 'round_corners_dark',
    'view_letters', 'view_inactive', 'view_render', 'view_guides', 'star', 'star_full',
    'square1', 'square2', 'square3', 'square4', 'square5', 'cloud', 'heart', 'clone', 'arrow_down',
    'crosshair', '90_right', '90_left'
];

// where to find static files
const staticFileAddress = productionMode ? '../wp-content/app/' : '/';

const loadImageFiles = () => {
    imageFiles.forEach(fileName => {
        game.load.image(fileName, `${staticFileAddress}images/${fileName}.png`);
    });
};

// called by main Phaser config (preload) even before the user clicks 'Start Beading' button
export const preload = () => {
    window.game = gameObject.scene.scenes[0];
    game.scale.on('resize', () => cameras.resize());
    loadImageFiles();
    settings.initialize();
};
